<pp-side-panel-menu-button
  [ppText]="'overview' | ppTranslate"
  [ppDataTarget]="'Overview button'"
  [ppDataTest]="'overviewMenuItem'"
  [ppIconSrc]="EIconPath.SIDE_PANEL_OVERVIEW"
  [ppActive]="ppRouterPath.startsWith('/site/overview')"
  [ppDisabled]="!user.activeWorkspaceId || ppDisabled"
  (ppAction)="goToOverview()"
></pp-side-panel-menu-button>
